<template>
  <page-wrap class="qyxx">
    <el-card class="box-card" style="width: 100%;">
      <h2 class="xpqd">基本信息</h2>
      <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
        <el-tab-pane label="基本信息" name="info">
          <el-form ref="form" :model="fromInfo" label-width="200px" onsubmit="return false">
            <el-form-item label="公司名称:" required>
              <el-input v-model="fromInfo.b_name" disabled class="input-item"></el-input>
              <el-popover
                placement="right"
                :offset="150"
                width="300"
                trigger="hover"
                content='1. 请填写营业执照上的公司名全称，如：北京富贵科技有限公司。
                                    2. 无公司名的个体工商户，请按“经营者姓名+（个体经营）”
                                        的格式 填写，如：张三（个体经营）。
                                    3. 请与营业执照上的公司名称保持一致，否则将无法通过审核'>
                <el-button type="text" style="margin-left: 10px;" slot="reference"
                           icon="el-icon-info"></el-button>
              </el-popover>
            </el-form-item>
            <el-form-item label="公司类型:" required>
              <el-select v-model="fromInfo.b_type" class="input-item" disabled>
                <el-option :value="1" label="企业"></el-option>
                <el-option :value="2" label="个体工商户"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经营模式:" required>
              <el-radio-group v-model="fromInfo.b_model" disabled>
                <el-radio :label="1">生产厂家</el-radio>
                <el-radio :label="2">经营批发</el-radio>
                <el-radio :label="3">商业服务</el-radio>
                <el-radio :label="4">招商代理</el-radio>
                <el-radio :label="0">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="主营行业:" required>
              <el-cascader class="input-item" @change="changeCategory" :options="category" disabled
                           v-model="c_id_arr">
              </el-cascader>
            </el-form-item>
            <el-form-item label="经营地址:" required>
              <el-cascader class="input-item" :options="area" v-model="area_id_arr" @change="changeArea"
                           @active-item-change="handleItemChange" :props="{value:'k'}">
              </el-cascader>
              <br/>
              <el-input class="city" v-model="fromInfo.address"
                        placeholder="请填写详细地址，不要重复填写省/市/区（县）"></el-input>
            </el-form-item>
            <el-form-item label="成立日期:" required>
              <el-date-picker type="date" placeholder="选择日期" v-model="fromInfo.found_time"
                              class="input-item"></el-date-picker>
            </el-form-item>
            <el-form-item label="公司介绍:" required>
              <el-input type="textarea" size="medium" v-model="fromInfo.detail" autosize></el-input>
              <el-popover
                placement="right-start"
                :offset="150"
                width="300"
                trigger="hover"
                content='1.请用中文填写贵公司概况、主管产品、品牌、服务等美容（50-200字）。
                                    2. 如果仅填写单纯的产品介绍，将有可能无法通过审核。
                                    3. 详细的介绍更容易使买家产生信赖感，仔细的填写将达到事半功倍的效果'>
                <el-button type="text" style="margin-left: 10px;" slot="reference"
                           icon="el-icon-info"></el-button>
              </el-popover>
            </el-form-item>

            <el-form-item label="公司网址:" required>
              <el-input v-model="fromInfo.official_url" class="input-item"
                        placeholder="请填写完整的网址，如：http://www.baidu.com"></el-input>
            </el-form-item>
            <el-form-item label="公司LOGO:">
              <el-upload
                action="/index.php/common/upload/image"
                :on-success="uploadLogo" :limit="1"
                :file-list="logoList"
                list-type="picture-card">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  请勿上传营业执照、证书或身份证等作为公司LOGO，且大小不超过2M的jpg，png，jpeg格式图片 ，否则将会被删除
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item class="submit_but">
              <el-button type="primary" @click="submitInfo">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="详细信息" name="detail">
          <el-form ref="form" :model="formDetail" label-width="200px" onsubmit="return false">
            <el-form-item label="法定代表人/负责人:">
              <el-input v-model="formDetail.c_person" class="input-item" placeholder="请填写姓名"></el-input>
            </el-form-item>
            <el-form-item label="公司注册地址:">
              <el-input v-model="formDetail.c_address" class="input-item"
                        placeholder="请填写注册地址信息"></el-input>
            </el-form-item>
            <el-form-item label="注册资本:">
              <el-input v-model="formDetail.c_money" class="input-item"
                        placeholder="请填写价值(人民币)"></el-input>
            </el-form-item>
            <el-form-item label="社会统一信用代码:">
              <el-input v-model="formDetail.c_credit_code" class="input-item"
                        placeholder="请填写社会统一信用代码"></el-input>
            </el-form-item>
            <el-form-item label="注册号:">
              <el-input v-model="formDetail.c_regis_mark" class="input-item"
                        placeholder="请填写注册号"></el-input>
            </el-form-item>
            <el-form-item label="经营范围:" required>
              <el-input type="textarea" size="medium" v-model="formDetail.c_range" autosize></el-input>
            </el-form-item>
            <el-form-item label="登记机关:">
              <el-input v-model="formDetail.c_regis_department" class="input-item"
                        placeholder="请填写登记机关"></el-input>
            </el-form-item>
            <el-form-item label="员工人数:">
              <el-input v-model="formDetail.c_person_num" class="input-item"
                        placeholder="请填写人数"></el-input>
              &nbsp;&nbsp;&nbsp;人
            </el-form-item>
            <el-form-item label="品牌名称:">
              <el-input v-model="formDetail.c_brand_name" class="input-item"
                        placeholder="请填写品牌名称"></el-input>
            </el-form-item>
            <el-form-item label="主要市场:" class="chebox_box">
              <el-checkbox-group v-model="formDetail.c_market">
                <el-checkbox label="1">华东地区</el-checkbox>
                <el-checkbox label="2">华南地区</el-checkbox>
                <el-checkbox label="3">华中地区</el-checkbox>
                <el-checkbox label="4">华北地区</el-checkbox>
                <el-checkbox label="5">西北地区</el-checkbox>
                <el-checkbox label="6">西南地区</el-checkbox>
                <el-checkbox label="7">东北地区</el-checkbox>
                <el-checkbox label="8">海南地区</el-checkbox>
                <el-checkbox label="9">港澳台地区</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="主要客户群体:">
              <el-input v-model="formDetail.c_cus_group" class="input-item"
                        placeholder="如超市、服装厂、印染厂等"></el-input>
            </el-form-item>
            <el-form-item label="提供对外加工／定制:">
              <el-radio-group v-model="formDetail.c_provide_make">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="加工方式:">
              <el-radio-group v-model="formDetail.c_make_type">
                <el-radio :label="1">来料加工</el-radio>
                <el-radio :label="2">来样加工</el-radio>
                <el-radio :label="3">OEM加工</el-radio>
                <el-radio :label="4">来图加工</el-radio>
                <el-radio :label="0">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="厂房面积:">
              <el-select v-model="formDetail.c_factory_area" class="input-item">
                <el-option :value="0" label="500平方米以下"></el-option>
                <el-option :value="1" label="1000平方米"></el-option>
                <el-option :value="2" label="5000平方米"></el-option>
                <el-option :value="3" label="1万平方米"></el-option>
                <el-option :value="4" label="3万平方米 "></el-option>
                <el-option :value="5" label="5万平方米以上"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="研发人员:">
              <el-select v-model="formDetail.c_coder_num" class="input-item">
                <el-option :value="0" label="少于5人"></el-option>
                <el-option :value="1" label="5-10人"></el-option>
                <el-option :value="2" label="11-20人"></el-option>
                <el-option :value="3" label="21-30人"></el-option>
                <el-option :value="4" label="31-40人 "></el-option>
                <el-option :value="5" label="41-50人"></el-option>
                <el-option :value="6" label="51-60人"></el-option>
                <el-option :value="7" label="61-70人"></el-option>
                <el-option :value="8" label="70人以上"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="月产量:">
              <el-input v-model="formDetail.c_month_output" class="input-item"
                        placeholder="请填写产量"></el-input>
              <el-input v-model="formDetail.c_month_output_unit" style="width: 70px"
                        placeholder="单位"></el-input>
            </el-form-item>
            <el-form-item label="年营业额:">
              <el-select v-model="formDetail.c_year_volume" class="input-item">
                <el-option :value="0" label="低于10万人民币"></el-option>
                <el-option :value="1" label="10万-50万人民币"></el-option>
                <el-option :value="2" label="50万-100万人民币"></el-option>
                <el-option :value="3" label="100万-500万人民币"></el-option>
                <el-option :value="4" label="500万-1000万人民币"></el-option>
                <el-option :value="5" label="1000万-5000万人民币"></el-option>
                <el-option :value="6" label="5000万-1亿人名币"></el-option>
                <el-option :value="7" label="超过1亿人名币"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年出口额:">
              <el-select v-model="formDetail.c_year_export" class="input-item">
                <el-option :value="0" label="低于10万人民币"></el-option>
                <el-option :value="1" label="10万-50万人民币"></el-option>
                <el-option :value="2" label="50万-100万人民币"></el-option>
                <el-option :value="3" label="100万-500万人民币"></el-option>
                <el-option :value="4" label="500万-1000万人民币"></el-option>
                <el-option :value="5" label="1000万-5000万人民币"></el-option>
                <el-option :value="6" label="5000万-1亿人名币"></el-option>
                <el-option :value="7" label="超过1亿人名币"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年入口额:">
              <el-select v-model="formDetail.c_year_import" class="input-item">
                <el-option :value="0" label="低于10万人民币"></el-option>
                <el-option :value="1" label="10万-50万人民币"></el-option>
                <el-option :value="2" label="50万-100万人民币"></el-option>
                <el-option :value="3" label="100万-500万人民币"></el-option>
                <el-option :value="4" label="500万-1000万人民币"></el-option>
                <el-option :value="5" label="1000万-5000万人民币"></el-option>
                <el-option :value="6" label="5000万-1亿人名币"></el-option>
                <el-option :value="7" label="超过1亿人名币"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="管理体系认证:">
              <el-radio-group v-model="formDetail.c_manage_system">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="1">ISO 9000</el-radio>
                <el-radio :label="2">ISO 9001</el-radio>
                <el-radio :label="3">ISO 9002</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="质量监控:">
              <el-radio-group v-model="formDetail.c_monitor_quality">
                <el-radio :label="0">内部</el-radio>
                <el-radio :label="1">第三方</el-radio>
                <el-radio :label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="submit_but">
              <el-button type="primary" @click="submitDetail">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </page-wrap>

</template>
<style>
  .input-item {
    width: 350px !important;
  }
</style>
<script>
  export default {
    data() {
      return {
        activeName: "info",
        fromInfo: {
          b_name: "",
          b_type: "2",
          b_model: "0",
          c_id: "0",
          province_id: '',
          city_id: '',
          area_id: '',
          address: '',
          found_time: "",
          detail: "",
          logo: ""
        },
        formDetail: {
          c_person: '',
          c_address: "",
          c_money: "",
          c_credit_code: '',
          c_regis_mark: '',
          c_range: '',
          c_regis_department: '',
          c_person_num: '',
          c_brand_name: '',
          c_market: ["1"],
          c_cus_group: "",
          c_provide_make: "1",
          c_make_type: "1",
          c_factory_area: "0",
          c_coder_num: "",
          c_month_output: "",
          c_month_output_unit: '',
          c_year_volume: "0",
          c_year_export: "0",
          c_year_import: "0",
          c_manage_system: "0",
          c_monitor_quality: "0",
        },
        category: [],
        c_id_arr: [],
        area: [],
        area_id_arr: [],
        logoList: []
      }
    },
    mounted() {
      document.getElementsByClassName('content')[0].style.height = '1000px'
      document.getElementsByClassName('sidebar')[0].style.height = '1000px'
      this.getCategory()
      this.getArea()
      this.getBusiness()
    },
    methods: {
      tabClick(tab) {
        console.log(tab.index)
        let h = tab.index == 0 ? 1000 : 1700;
        console.log(h)
        document.getElementsByClassName('content')[0].style.height = h + 'px'
        document.getElementsByClassName('sidebar')[0].style.height = h + 'px'
      },
      getBusiness() {
        let that = this
        this.$ajax.get('business/company/getInfo').then(function (res) {
          if (res.data.error === 0) {
            that.fromInfo = res.data.data.info
            that.formDetail = res.data.data.detail
            that.c_id_arr = res.data.data.c_id_arr
            that.area_id_arr = res.data.data.area_id_arr
            that.logoList = [{name: res.data.data.info.logo, url: res.data.data.info.logo}]
            that.getArea([res.data.data.area_id_arr[0]])
            setTimeout(() => that.getArea([res.data.data.area_id_arr[0], res.data.data.area_id_arr[1]]), 3000)
            setTimeout(() => that.getArea(res.data.data.area_id_arr), 6000)
          }
        })
      },
      getCategory() {
        let that = this
        this.$ajax.get('common/find/category_cascade').then(function (res) {
          if (res.data.error === 0) {
            that.category = res.data.data
          }
        })
      },
      getArea(val = [-1]) {
        let that = this
        let len = val.length
        let pid = 0
        if (val[0] !== -1) {
          pid = len === 1 ? this.area[val[0]].area_id : (len === 2 ? this.area[val[0]].children[val[1]].area_id :
            this.area[val[0]].children[val[1]].children[val[2]].area_id);
        }
        this.$ajax.get('common/find/area_cascade?pid=' + pid).then(function (res) {
          if (res.data.error === 0) {
            if (val[0] === -1) {
              that.area = res.data.data
            } else {
              if (len === 1) {
                that.area[val[0]].children = res.data.data;
              }
              if (len === 2) {
                that.area[val[0]].children[val[1]].children = res.data.data;
              }
              if (len === 3) {
                that.area[val[0]].children[val[1]].children[val[2]].children = res.data.data;
              }
            }
          }
        })
      },
      changeCategory(v) {
        this.fromInfo.c_id = v.pop()
      },
      handleItemChange(val) {
        console.log(val)
        this.getArea(val)
      },
      changeArea(val) {
//                console.log(val)
        if (val.length === 1) {
          this.fromInfo.province_id = this.area[val[0]].area_id;
        } else if (val.length === 2) {
          this.fromInfo.province_id = this.area[val[0]].area_id;
          this.fromInfo.city_id = this.area[val[0]].children[val[1]].area_id
        } else {
          this.fromInfo.province_id = this.area[val[0]].area_id;
          this.fromInfo.city_id = this.area[val[0]].children[val[1]].area_id
          this.fromInfo.area_id = this.area[val[0]].children[val[1]].children[val[2]].area_id
        }
      },
      uploadLogo(response, file, fileList) {
        if (response.error === 0) {
          this.fromInfo.logo = response.data
        } else {
          this.$message.error(response.message);
          this.logoList = []
        }
      },
      submitInfo() {
        let that = this
        this.$ajax.post('business/company/postInfo', this.fromInfo).then(function (res) {
          if (res.data.error === 0) {
            that.$message.success('保存成功！')
          } else {
            that.$message.error(res.data.message)
          }
        })
      },
      submitDetail() {
        let that = this
        this.$ajax.post('business/company/postDetail', this.formDetail).then(function (res) {
          if (res.data.error === 0) {
            that.$message.success('保存成功！')
          } else {
            that.$message.error(res.data.message)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/business/Company.vue